import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import CircularProgress from '@material-ui/core/CircularProgress';
import FullScreenLoader from '../../components/FullScreenLoader';
import SignUpFormLawFirmInfo from './components/SignUpFormLawFirmInfo';
import SignUpFormLawyerInfo from './components/SignUpFormLawyerInfo';
import { addFormValues } from '../../store/modules/formValues';
import { assertionStepSubmittedAction } from '../../store/modules/assertionStepsSubmitted';
import { validationLawFirm, validationLawyer } from '../../utils/validations';

class SignUpInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        officeName: '',
        name: '',
        firstLastName: '',
        secondLastName: '',
        gender: 'male',
      },
      isInitialValid: false,
      redirect: false,
      loading: false,
      loadingFormData: true,
      error: null,
    };
  }

  componentDidMount() {
    const {
      formValues,
      isFirstStepSubmitted,
      isSecondStepSubmitted,
    } = this.props;
    if (isFirstStepSubmitted) {
      if (isSecondStepSubmitted) {
        this.setState({
          initialValues: { ...formValues },
          isInitialValid: true,
          loadingFormData: false,
        });
      } else {
        this.setState({ loadingFormData: false });
      }
    } else {
      this.setState({ loadingFormData: false, redirect: true });
    }
  }

  handleSubmit = (values, actions) => {
    const { submitFormValues } = this.props;
    this.setState({ loading: true });
    setTimeout(() => {
      submitFormValues(values).then(() => {
        this.assertionStepSubmitted();
      });
    }, 1000);
  };

  assertionStepSubmitted = () => {
    const { submitStep, isLawyer, history } = this.props;
    submitStep({
      personalInformation: true,
    }).then(res => {
      let url = isLawyer ? '/registro-abogados/abogado' : '/registro-abogados/despacho';
      history.push(url);
    });
  };

  render() {
    const {
      isInitialValid,
      initialValues,
      loading,
      loadingFormData,
      redirect,
    } = this.state;
    const { isLawyer } = this.props;

    if (loadingFormData) {
      return (
        <div className="flexContainer--center">
          <CircularProgress color="secondary" />
        </div>
      );
    }

    if (redirect) {
      return <Redirect to="/registro-abogados" />;
    }

    return (
      <>
        <FullScreenLoader loading={loading} />
        <Formik
          initialValues={initialValues}
          isInitialValid={isInitialValid}
          validationSchema={isLawyer ? validationLawyer : validationLawFirm}
          onSubmit={this.handleSubmit}
          render={props => {
            if (isLawyer) {
              return <SignUpFormLawyerInfo {...props} />;
            } else {
              return <SignUpFormLawFirmInfo {...props} />;
            }
          }}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  formValues: state.formValues,
  isLawyer: state.stepsSubmitted.accountType === 'lawyer',
  isFirstStepSubmitted: state.stepsSubmitted.accountType,
  isSecondStepSubmitted: state.stepsSubmitted.personalInformation,
});

const mapDispatchToProps = dispatch => ({
  submitFormValues: formValues => dispatch(addFormValues(formValues)),
  submitStep: steps => dispatch(assertionStepSubmittedAction(steps)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUpInfo);
